// ============================================================================
// HEBREW TRANSLATIONS - BIBLE FACTS
// ============================================================================
// עובדות מעניינות על התנ"ך

export const bibleFactsHe = [
  {
    category: "מבנה",
    text: "התנ\"ך מורכב מ-66 ספרים שנכתבו על ידי יותר מ-40 סופרים במשך כ-1500 שנה",
    source: "מחקרי תנ\"ך"
  },
  {
    category: "תרגום",
    text: "התנ\"ך הוא הספר המתורגם ביותר בהיסטוריה, עם תרגומים ליותר מ-3000 שפות",
    source: "ויקליף לתרגום התנ\"ך"
  },
  {
    category: "פסוקים",
    text: "התנ\"ך כולו מכיל 31,173 פסוקים, מהם 23,214 בתנ\"ך העברי ו-7,959 בברית החדשה",
    source: "סטטיסטיקות תנ\"ך"
  },
  {
    category: "השפעה",
    text: "תהלים הוא הספר הארוך ביותר בתנ\"ך ומכיל 150 מזמורים, בעוד עובדיה הוא הקצר ביותר",
    source: "ניתוח תנ\"ך"
  },
  {
    category: "היסטוריה",
    text: "מגילות מדבר יהודה מכילות כתבי יד של התנ\"ך מהמאה השלישית לפנה\"ס עד המאה הראשונה לספירה, ומאששות את אמינות הטקסט המקראי",
    source: "ממצאים ארכיאולוגיים"
  },
  {
    category: "ספרות",
    text: "התנ\"ך כולל ז'אנרים ספרותיים מגוונים: היסטוריה, שירה, נבואה, איגרות, ואפוקליפסה",
    source: "ניתוח ספרותי"
  },
  {
    category: "אוניברסליות",
    text: "התנ\"ך הוא הספר הנקרא ביותר בהיסטוריה, עם מיליוני עותקים המופצים מדי שנה ומשפיע על כל התרבויות",
    source: "סטטיסטיקות עולמיות"
  }
];

export default bibleFactsHe;
